import { lang } from '@umu/ukit-lang';
import React, { useMemo } from 'react';

import { components } from 'common';
const { If } = components;
import { bizComponents, bizUtils } from 'businessCommon';
const { ImgSpareTire } = bizComponents;
const { crrencySymbol } = bizUtils;
import { getCurrentPrice } from 'market/@marketCommon/utils/course';

import { ICourseResourceInfo } from 'market/@marketCommon/interface/recommend';

import './courseItem.scss';
import { CourseTag } from '../courseTag/courseTag';
import { RenderDuration } from '../RenderDuration';
import { CourseType } from '../marketHeader/service';

interface IProps {
    resourceInfo: ICourseResourceInfo;
}

export const CourseItem = ({ resourceInfo }: IProps) => {
    const peopleCard = useMemo(() => {
        if (resourceInfo.student_num && resourceInfo.student_num > 100) {
            return (
                <div className="student-container">
                    <img className="student-icon" src={require('./images/people.png')} />
                    <span className="student-num">{resourceInfo.student_num}</span>
                </div>
            );
        }
        return null;
    }, [resourceInfo]);

    const cardDesc = useMemo(() => {
        if (resourceInfo.store_info) {
            return (
                <div className="owner-desc">
                    <div className="owner-name-container">
                        <span className="owner-name">{resourceInfo.store_info.title}</span>
                        {resourceInfo.lecturer_list ? resourceInfo.lecturer_list.map(({ name }) => name).join(' ') : ''}
                    </div>
                    {peopleCard}
                </div>
            );
        }

        return (
            <div className="owner-desc">
                <div className="owner-name-container">
                    <span className="owner-name">{resourceInfo.m_owner_name || resourceInfo.owner_name}</span>
                    {resourceInfo.m_owner_desc || resourceInfo.owner_desc}
                </div>
                {peopleCard}
            </div>
        );
    }, [resourceInfo, peopleCard]);

    const render = () => {
        const courseId = resourceInfo.encrypted_id;
        const categoryId = resourceInfo.category_id;
        const productLabelName = resourceInfo.product_label_name;
        const sessionNum = resourceInfo.session_num || 0;
        const coverUrl = resourceInfo.m_cover_url || resourceInfo.cover_url || 'empty';
        return (
            <a
                key={courseId}
                target="_self"
                className="course-recommend-item"
                href={`/market/category/${categoryId}/course/${courseId}`}
            >
                <div className="img-container">
                    <ImgSpareTire src={coverUrl} />
                    <CourseTag tag={productLabelName} />
                </div>
                <div className="info">
                    <div className="title umu-text-clamp clamp-2">
                        {resourceInfo.m_obj_title || resourceInfo.obj_title}
                    </div>
                    {cardDesc}
                    <div className="stat">
                        <div className="count umu-text-clamp clamp-1">
                            <span className="num">{lang('共{$0{0=节,1=节}}', sessionNum)}</span>
                            <RenderDuration duration={resourceInfo.duration} />
                        </div>
                        {Number(resourceInfo?.course_type) !== CourseType.Mercer && (
                            <div className="price">
                                <If condition={!!resourceInfo.price && Number(resourceInfo.price) > 0}>
                                    <span className="crrency-symbol">{crrencySymbol}</span>
                                </If>
                                {getCurrentPrice(resourceInfo.price)}
                            </div>
                        )}
                    </div>
                </div>
            </a>
        );
    };

    return render();
};
